var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 30.6667H5.99992C4.53325 30.6667 3.33325 29.4667 3.33325 28V9.33334H5.99992V28H24.6666V30.6667ZM20.6666 1.33334H11.3333C9.86658 1.33334 8.67992 2.53334 8.67992 4.00001L8.66658 22.6667C8.66658 24.1333 9.85325 25.3333 11.3199 25.3333H25.9999C27.4666 25.3333 28.6666 24.1333 28.6666 22.6667V9.33334L20.6666 1.33334ZM25.9999 22.6667H11.3333V4.00001H19.5599L25.9999 10.44V22.6667Z",
    fill: "#3D96C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9998 9.72083V12.3875H22.6665V15.0542H19.9998V17.7208H17.3332V15.0542H14.6665V12.3875H17.3332V9.72083H19.9998Z",
    fill: "#3D96C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add_file.c7b6ae58d3f198ed66665dd531ac1cb6.svg";
export { ForwardRef as ReactComponent };